import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import { toastAlert } from "../../lib/toastAlert";
import { useNavigate } from "react-router-dom";

import chargeSample from "../../assets/images/Users.xlsx"
import isEmpty from '../../lib/isEmpty';
import { CreateAndCheckValid } from '../../actions/users';
import { FaDownload } from "react-icons/fa";

const initialFormValue = {
    'name': "",
    'email': "",
    'phonenumber': "",
    'address1': "",
    'address2': "",
    'pincode': "",
    'city': "",
    'country': "",
    'Photofile': "",

}

const UserAdd = () => {
    const navigate = useNavigate();

    const [file, setFile] = useState({})

    const onChangehandler = async (e) => {
        var file = e.target.files[0]
        setFile(file)
    }

    const addusers = async () => {
        if (isEmpty(file)) {
            var formdata = new FormData()
            formdata.append("excel", file)
            var resp = await CreateAndCheckValid(formdata)
            if (resp?.status) {
                toastAlert("success", resp.msg)
                setFile({})
                setTimeout(() => {
                    navigate('/UserList')
                }, 1000);
            }
            else {
                toastAlert("error", resp?.msg)
            }

        }
        else {
            toastAlert("error", "Please Select the File")
        }


    }

    return (
        <>
            <Container fluid className="common_bg position-relative">
                <div className="liner"></div>
                <Row>
                    <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
                        <Sidebar />
                    </Col>
                    <Col xl={10} lg={12}>
                        <Header title={'Add User'} />
                        <div className='common_page_scroller mt-5 pe-2'>

                        <button className='btn addcate' onClick={()=>navigate(-1)}>Back</button>

                            <div className="addcategorys mb-3">
                                <h4>Add User</h4>
                            </div>
                             
                             <div className='row'>
                            <div className='col-xl-5 mt-3'>
                                <p className='mb-0 text-white'>You can download your sample excel sheet format here</p>
                                <a href={chargeSample} >
                                    <FaDownload className='text-danger' />
                                </a>
                            </div>


                            <div className='col-xl-5 mt-3 mb-3'>
                                <label className='mb-2'>Image</label><br></br>
                                <input type="file" className='inputfileadd' onChange={(e) => {
                                    onChangehandler(e)
                                }} style={{ flexDirection: 'row-reverse', }} />
                            </div>
                            </div>

                            <div className='mt-5'>
                                <button type="button" className="btn addcate" onClick={() => addusers()} >Submit</button>
                            </div>

                        </div>

                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default UserAdd